import { ConnectionAddressObject } from "@origin-digital/address-lookup";
import { dapiFetchCacheWithSumoErrorLogging } from "../utils/daxi/daxi.utils";

export interface IOriginAddress {
  flatUnitType?: string;
  flatUnitNumber?: string;
  houseNumber: string;
  streetName: string;
  streetType: string;
  suburbLocality: string;
  stateTerritory: string;
  state: string;
  postcode: string;
  addressId: string;
  nmi?: string;
  mirn?: string;
  isMIRNOnSupply?: boolean;
  isNMIOnSupply?: boolean;
}

const mapOriginAddressResponse = (
  addressResp: IOriginAddress | undefined
): ConnectionAddressObject | undefined => {
  if (addressResp) {
    return {
      qasAddress: {
        unit: addressResp.flatUnitNumber
          ? `${addressResp.flatUnitType || ""} ${
              addressResp.flatUnitNumber
            }`.trim()
          : undefined,
        streetNumber: addressResp.houseNumber,
        streetName: [addressResp.streetName, addressResp.streetType]
          .filter(Boolean)
          .join(" "),
        streetType: addressResp.streetType,
        city: addressResp.suburbLocality,
        state: addressResp.state,
        postcode: addressResp.postcode,
        dpid: null,
      },
      qasSearchResult: undefined,
      originAddressId: addressResp.addressId,
      isManualAddress: false,
      nmi: addressResp.nmi,
      mirn: addressResp.mirn,
      isMIRNOnSupply: !!addressResp.isMIRNOnSupply,
      isNMIOnSupply: !!addressResp.isNMIOnSupply,
    };
  }
  return undefined;
};

/**
 * Uses the address reverse lookup api to get the sap address fragments and maps it to the
 * ConnectionAddressObject model we use for our connection address.
 *
 * @param originAddressId
 */
export const originAddressReverseLookup = async (
  originAddressId: string
): Promise<ConnectionAddressObject | undefined> => {
  try {
    const response = await dapiFetchCacheWithSumoErrorLogging<IOriginAddress>(
      `${TAL.config.addressSelector.addressReverseLookupExt}/${originAddressId}`
    );
    return mapOriginAddressResponse(response.data);
  } catch (e) {
    return undefined;
  }
};
